export const background = {
  backgroundColor: '#172b57',
  padding: 10,
}
